import { IClientType, CardBrands, BpaPaymentSystem, EntityStatus, TCustomersSortBy } from 'types';

export const clientTypes: IClientType[] = [
	{ clientTypeID: 1, clientTypeName: 'clientTypeHotels' },
	{ clientTypeID: 2, clientTypeName: 'clientTypeRestaurants' },
	{ clientTypeID: 3, clientTypeName: 'clientTypeFastFood' },
];

export const entityStatuses: { id: EntityStatus; name: string }[] = [
	{ id: EntityStatus.Active, name: 'statusActive' },
	{ id: EntityStatus.Archived, name: 'statusArchived' },
	{ id: EntityStatus.Deleted, name: 'statusDeleted' },
];

export const customersSortOptions: { value: TCustomersSortBy; translationKey: string }[] = [
	{ value: 'NameA-Z', translationKey: 'sortByNameA-Z' },
	{ value: 'NameZ-A', translationKey: 'sortByNameZ-A' },
	{ value: 'Rest/Hotel1-10', translationKey: 'sortByRestHotel1-10' },
	{ value: 'Rest/Hotel10-1', translationKey: 'sortByRestHotel10-1' },
];

export const cardBrands = [
	{ id: CardBrands.Visa, name: CardBrands.Visa },
	{ id: CardBrands.VisaElectron, name: CardBrands.VisaElectron },
	{ id: CardBrands.Mastercard, name: CardBrands.Mastercard },
	{ id: CardBrands.Maestro, name: CardBrands.Maestro },
	{ id: CardBrands.AMEX, name: CardBrands.AMEX },
	{ id: CardBrands.UPI, name: CardBrands.UPI },
	{ id: CardBrands.JCB, name: CardBrands.JCB },
	{ id: CardBrands.Diners, name: CardBrands.Diners },
	{ id: CardBrands.Girocard, name: CardBrands.Girocard },
	{ id: CardBrands.Mir, name: CardBrands.Mir },
	{ id: CardBrands.CB, name: CardBrands.CB },
];

export const bpaPaymentSystem = [
	{ id: BpaPaymentSystem.M4Bank, name: BpaPaymentSystem.M4Bank },
	{ id: BpaPaymentSystem.Tieto, name: BpaPaymentSystem.Tieto },
	{ id: BpaPaymentSystem.SBP, name: BpaPaymentSystem.SBP },
];

export const NEW_BPA_BLOCK_PREFIX = 'newBPABlock';
export const NEW_BPA_TARIFF_PREFIX = 'newBPATariff';
